import Sidebar from './Sidebar';

const AdminSidebar = () => {
  return <Sidebar role="admin" />;
};

export default AdminSidebar;